<template>
<div>
<transition name="fade" mode="in-out">
  <v-card v-if="!load && graficos.length > 0" flat :disabled="load" :loading="load" class="pr-4 pl-4">
    <v-card-title>
      Desempenho
      <v-spacer />
      <div class="primary--text">Total OS: <strong class="black--text">{{osLiberadas}}</strong></div>
    </v-card-title>
    <v-layout v-if="graficos.length > 0 && !load" row>
      <v-flex md4 class="pl-1 pr-1" v-for="g in graficos" :key="g.id">
        <radialProcent :serie="Math.floor(g.peso)"></radialProcent>
        <div v-if="g.id == 'chartdiv3'">
          <osLiberacaoPendente :data="data" :btnNome="g.titulo"></osLiberacaoPendente>
        </div>
        <div v-if="g.id != 'chartdiv3'">
          <v-alert border="top" dense color="primary" dark>
            {{g.titulo}}
          </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</transition>
<transition name="fade" mode="out-in">
  <v-card v-if="load">
    <v-card flat disabled>
      <v-card-title>
        Desempenho
        <v-spacer />
        <div class="primary--text">Total OS: <strong class="black--text">{{osLiberadas}}</strong></div>
      </v-card-title>
    </v-card>
    <v-layout row class="mx-2">
      <v-flex md4 class="px-1">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-flex>
      <v-flex md4 class="px-1">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-flex>
      <v-flex md4 class="px-1">
        <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
      </v-flex>
    </v-layout>
  </v-card>
</transition>
</div>
</template>

<script>
import service from '../services/userservice'
import osLiberacaoPendente from './osLiberacaoPendente'
import radial from './chartPorcentagem'
import { EventBus } from './../main'

export default {
  name: 'analisesPorcentagem',
  props: {
    data: Object
  },
  data () {
    return {
      load: false,
      graficos: [],
      osLiberadas: 0
    }
  },
  components: {
    osLiberacaoPendente: osLiberacaoPendente,
    radialProcent: radial
  },
  methods: {
    carregarAnalise () {
      this.load = true
      this.osLiberadas = 0
      EventBus.$emit('loadStop', 1)
      if (this.data != null) {
        service.analiseLiberacao(this.data).then(r => {
          if (r.status === 200) {
            this.graficos = r.data.analise
            this.osLiberadas = r.data.totalOs
            // this.criarGrafico(r.data.analise)
          } else if (r.status === 203) {
            // this.isMsg = true
          }
        }).finally(() => {
          // this.load = false
          EventBus.$emit('loadStop', -1)
        })
      }
    },
    limparDados () {
      this.graficos = []
      this.osLiberadas = 0
    },
    loadStop (is) {
      this.load = is
    }
  },
  watch: {
    data: function (val) {
      this.carregarAnalise()
    }
  },
  mounted () {
    EventBus.$on('limpar-dados', this.limparDados)
    EventBus.$on('load', this.loadStop)
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
